"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishlistSyncedEvent = void 0;
const event_type_1 = require("../enums/event-type");
class WishlistSyncedEvent {
    constructor() {
        this.eventType = WishlistSyncedEvent.EventType;
        this.timestamp = new Date();
    }
}
exports.WishlistSyncedEvent = WishlistSyncedEvent;
WishlistSyncedEvent.EventType = event_type_1.WishlistServiceEventType.WISHLIST_SYNCED;
